import React, { Component } from 'react';
import styled from 'styled-components';

import Image from '../../common/Image';

import EmployList from '../../teamData/teamEmployr';
import mediaWidth, { Width } from '../../utils/mediaWidth/mediaWidth';

// count image on screen
const CountImage = {
    S: 9,
    M: 15,
    L: 18,
};

const indexWithFilter = {
    S: [0, 2, 4, 5, 7],
    M: [0, 2, 4, 6, 7, 9, 11, 13],
    L: [0, 2, 4, 5, 7, 8, 10, 13, 15, 17],
};

const getIsFilter = (charSize, index, isInvertIndexFilter) => {
    const partOneTernar = (indexWithFilter[charSize].indexOf(index) !== -1 && !isInvertIndexFilter);
    const partTwoTernar = (indexWithFilter[charSize].indexOf(index) === -1 && isInvertIndexFilter);
    return partOneTernar || partTwoTernar;
};

const TimeMix = 1; // s

class OtherTalents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mixedImages: [],
            currentPart: 0,
        };
        this.charSize = 'S';
        this.maxParts = Math.ceil(EmployList.length / CountImage[this.charSize]);
        this.intervalChanges = null;
        this.isInvertIndexFilter = false;
    }

    componentDidMount() {
        if (window.innerWidth >= Width.M && window.innerWidth < Width.L) this.charSize = 'M';
        if (window.innerWidth >= Width.L) this.charSize = 'L';
        this.maxParts = Math.ceil(EmployList.length / CountImage[this.charSize]);
        this.setMixImage();
        this.startChangeImages();
    }

    componentWillUnmount() {
        clearInterval(this.intervalChanges);
    }


    setMixImage() {
        const parts = [];
        const sortedList = EmployList.sort(() => Math.random() - 0.5);
        Array(this.maxParts).fill(0).forEach((_, indexPart) => {
            parts.push(sortedList.slice(
                indexPart * CountImage[this.charSize],
                (indexPart + 1) * CountImage[this.charSize],
            ));
        });

        if (parts[parts.length - 1].length < CountImage[this.charSize]) {
            parts[parts.length - 1].push(...EmployList.slice(
                0,
                (CountImage[this.charSize] - parts[parts.length - 1].length),
            ));
        }

        this.setState({
            mixedImages: parts,
        });
    }

    startChangeImages() {
        setTimeout(() => {
            this.intervalChanges = setInterval(() => {
                const { currentPart } = this.state;
                this.isInvertIndexFilter = !this.isInvertIndexFilter;
                this.setState({
                    currentPart: currentPart + 1 <= this.maxParts - 1 ? currentPart + 1 : 0,
                });
            }, TimeMix * 1000);
        }, TimeMix * 1000);
    }

    render() {
        const { mixedImages, currentPart } = this.state;
        const { className } = this.props;

        return (
            <Root className={className}>
                {mixedImages.length > 0 && mixedImages.map((images, indexImages) => (
                    mixedImages[indexImages].map((employSrc, index) => (
                        <FilterWrapper
                            style={{ display: indexImages === currentPart ? 'block' : 'none' }}
                            withBlueFilter={getIsFilter(
                                this.charSize,
                                index,
                                this.isInvertIndexFilter,
                            )}
                            maxParts={this.maxParts}
                            key={index.toString()}
                            lengthImages={images.length}
                        >
                            <Image src={employSrc} />
                        </FilterWrapper>
                    ))
                ))}
            </Root>
        );
    }
}

const Root = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
`;

const FilterWrapper = styled.div`
    width: 100px;
    height: 100px;    
    position: relative;

    ${({ withBlueFilter }) => (withBlueFilter && `
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100px;
            height: 100px;
            border-radius: 100%;
            background: #0032A0;
            mix-blend-mode: hard-light;
            opacity: 0.35;
        }
    `)};
    
    @media (max-width: ${Width.M - 1}px) {
        &:nth-child(2) { margin: 0 14px; }
        &:nth-child(4) { margin: 14px 0; }
        &:nth-child(5) { margin: 14px; }
        &:nth-child(6) { margin: 14px 0; }
        &:nth-child(8) { margin: 0 14px; }
        ${({ maxParts, lengthImages }) => Array(maxParts).fill(0).map((_, index) => `
            &:nth-child(${2 + ((index + 1) * lengthImages)}) { margin: 0 14px; }
            &:nth-child(${4 + ((index + 1) * lengthImages)}) { margin: 14px 0; }
            &:nth-child(${5 + ((index + 1) * lengthImages)}) { margin: 14px; }
            &:nth-child(${6 + ((index + 1) * lengthImages)}) { margin: 14px 0; }
            &:nth-child(${8 + ((index + 1) * lengthImages)}) { margin: 0 14px; }
        `)}
    }
    
    @media (min-width: ${Width.M}px) and (max-width: ${Width.L - 1}px) {
          &:nth-child(5n + 1) { margin-right: 32px; }
          &:nth-child(5n + 2) { margin-right: 32px; }
          &:nth-child(5n + 3) { margin-right: 32px; }
          &:nth-child(5n + 4) { margin-right: 32px; }
          &:nth-child(n + 6):nth-child(-n + 10) { margin-top: 32px; margin-bottom: 32px; }
          ${({ maxParts, lengthImages }) => Array(maxParts).fill(0).map((_, index) => `&:nth-child(n + ${6 + ((index + 1) * lengthImages)}):nth-child(-n + ${10 + ((index + 1) * lengthImages)}) { margin-top: 32px; margin-bottom: 32px; }`)}
    }
    
    ${mediaWidth.l} {
          &:nth-child(6n + 1) { margin-right: 21px; }
          &:nth-child(6n + 2) { margin-right: 21px; }
          &:nth-child(6n + 3) { margin-right: 21px; }
          &:nth-child(6n + 4) { margin-right: 21px; }
          &:nth-child(6n + 5) { margin-right: 21px; }
          &:nth-child(n + 7):nth-child(-n + 12) { margin-top: 36px; margin-bottom: 36px; }
          ${({ maxParts, lengthImages }) => Array(maxParts).fill(0).map((_, index) => `&:nth-child(n + ${7 + ((index + 1) * lengthImages)}):nth-child(-n + ${12 + ((index + 1) * lengthImages)}) { margin-top: 36px; margin-bottom: 36px; }`)}
    }
    /* ${mediaWidth.xl} {
          &:nth-child(6n + 1) { margin-right: 30px; }
          &:nth-child(6n + 2) { margin-right: 30px; }
          &:nth-child(6n + 3) { margin-right: 30px; }
          &:nth-child(6n + 4) { margin-right: 30px; }
          &:nth-child(6n + 5) { margin-right: 30px; }
    } */
    ${mediaWidth.m} {
        width: 108px;
        height: 108px;
        
        ${({ withBlueFilter }) => (withBlueFilter && `
            &::after {
                width: 108px;
                height: 108px;
            }
        `)};
    }
    ${mediaWidth.l} {
        width: 129px;
        height: 129px;
        
        ${({ withBlueFilter }) => (withBlueFilter && `
            &::after {
                width: 129px;
                height: 129px;
            }
        `)};
    }
    ${mediaWidth.xl} {
        width: 187px;
        height: 187px;
        
        ${({ withBlueFilter }) => (withBlueFilter && `
            &::after {
                width: 187px;
                height: 187px;
            }
        `)};
    }
`;

export default OtherTalents;
